module.exports = __webpack_public_path__ + "static/media/ALTHAR_WEB_VR-for-Oncology-Management.0f618972.png";